// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3FQsa","requiredAsterisk":"Info_requiredAsterisk__35lvX"};